module.exports = __webpack_public_path__ + "media/images/gallery/gc_off-2358bdb26a961b9ed88830117721193f.gif";